import type { Position } from '../../types';

export type RoleFamily = 'GOALKEEPER' | 'CENTRE_BACK' | 'FULL_BACK' | 'WING_BACK' | 'HOLDING_MIDFIELDER'
  | 'CENTRAL_MIDFIELDER' | 'ATTACKING_MIDFIELDER' | 'WINGER' | 'STRIKER';

export interface RoleProfile {
  family: RoleFamily;
  runPriority: number;
  pressPriority: number;
  coverPriority: number;
  supportDepth: number;
  advanceBias: number;
  widthInfluence: number;
}

const PROFILES: Record<RoleFamily, RoleProfile> = {
  GOALKEEPER: { family: 'GOALKEEPER', runPriority: -100, pressPriority: -100, coverPriority: -100, supportDepth: 28, advanceBias: 0, widthInfluence: 0 },
  CENTRE_BACK: { family: 'CENTRE_BACK', runPriority: -25, pressPriority: 4, coverPriority: 30, supportDepth: 22, advanceBias: -2, widthInfluence: 0.2 },
  FULL_BACK: { family: 'FULL_BACK', runPriority: 8, pressPriority: 12, coverPriority: 18, supportDepth: 17, advanceBias: 3, widthInfluence: 0.85 },
  WING_BACK: { family: 'WING_BACK', runPriority: 22, pressPriority: 16, coverPriority: 12, supportDepth: 14, advanceBias: 7, widthInfluence: 1 },
  HOLDING_MIDFIELDER: { family: 'HOLDING_MIDFIELDER', runPriority: -3, pressPriority: 18, coverPriority: 26, supportDepth: 16, advanceBias: 0, widthInfluence: 0.25 },
  CENTRAL_MIDFIELDER: { family: 'CENTRAL_MIDFIELDER', runPriority: 13, pressPriority: 16, coverPriority: 14, supportDepth: 12, advanceBias: 4, widthInfluence: 0.45 },
  ATTACKING_MIDFIELDER: { family: 'ATTACKING_MIDFIELDER', runPriority: 28, pressPriority: 12, coverPriority: 4, supportDepth: 8, advanceBias: 8, widthInfluence: 0.4 },
  WINGER: { family: 'WINGER', runPriority: 35, pressPriority: 10, coverPriority: 2, supportDepth: 8, advanceBias: 10, widthInfluence: 1 },
  STRIKER: { family: 'STRIKER', runPriority: 42, pressPriority: 8, coverPriority: 0, supportDepth: 7, advanceBias: 12, widthInfluence: 0.25 },
};

export function roleFamily(role: string, position: Position): RoleFamily {
  const normalized = role.toUpperCase();
  if (normalized === 'GK' || position === 'GK') return 'GOALKEEPER';
  if (normalized === 'CB' || normalized === 'CENTRAL' || normalized === 'LIBERO') return 'CENTRE_BACK';
  if (normalized === 'LB' || normalized === 'RB' || normalized === 'LATERAL') return 'FULL_BACK';
  if (normalized === 'LWB' || normalized === 'RWB') return 'WING_BACK';
  if (normalized === 'DM' || normalized === 'BALL_WINNER') return 'HOLDING_MIDFIELDER';
  if (normalized === 'AM' || normalized === 'ATTACKING_MIDFIELDER') return 'ATTACKING_MIDFIELDER';
  if (['LM', 'RM', 'LW', 'RW', 'WINGER'].includes(normalized)) return 'WINGER';
  if (['ST', 'FINISHER', 'SECOND_STRIKER'].includes(normalized) || position === 'FW') return 'STRIKER';
  if (position === 'DF') return 'CENTRE_BACK';
  if (position === 'MF') return 'CENTRAL_MIDFIELDER';
  return 'STRIKER';
}

export function roleProfile(role: string, position: Position): RoleProfile {
  return PROFILES[roleFamily(role, position)];
}
